var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "where-is-my-data" },
    [
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ],
        staticClass: "icon icon-loading"
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isEditingLocation && !_vm.isLoading,
              expression: "!isEditingLocation && !isLoading"
            }
          ]
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.country,
                  expression: "country"
                }
              ]
            },
            [
              _vm._v(_vm._s(_vm.label)),
              _c("strong", [_vm._v(_vm._s(_vm.country) + ".")])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.country,
                  expression: "!country"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.labelForNoCountry))]
          ),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAdmin,
                expression: "isAdmin"
              }
            ],
            staticClass: "icon icon-rename",
            on: { click: _vm.editLocation }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEditingLocation && !_vm.isLoading,
              expression: "isEditingLocation && !isLoading"
            }
          ],
          staticClass: "multiselect-container"
        },
        [
          _c("multiselect", {
            attrs: {
              disabled: _vm.isSavingChanges,
              options: _vm.options,
              searchable: true,
              "track-by": "code",
              label: "label",
              placeholder: _vm.placeholderLabel
            },
            on: { input: _vm.onChange }
          }),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSavingChanges,
                expression: "isSavingChanges"
              }
            ],
            staticClass: "icon icon-loading"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Map", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }